import { forwardRef, type InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { error, className, ...rest },
  ref,
) {
  const cls = ['ds-input', error && 'ds-input--error', className].filter(Boolean).join(' ');
  return <input ref={ref} className={cls} {...rest} />;
});
